import { useState, useCallback, useContext, useEffect } from "react";
import { ReactReduxContext } from 'react-redux';

import {
  setRequestError
} from "../actions/index";

const useGetFromApiSearch = (id, path, isBaseRootApi = true, type, perPage = 100) => {
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const state = store.getState();
  const [response, setResponse] = useState(null);

  const onLoadMore = useCallback((nextPath, isSplice) => (callback) => loadMore(nextPath, isSplice, callback), []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadMore = useCallback((nextPath, isSplice = false, callback) => {
    if (state.api && nextPath) {
      const url = nextPath.includes(`http`) ? nextPath : `https://${nextPath}`;
      state.api.getFromURL(url).then( res => {

        const results = (res.data[type]) ? res.data[type] : [];

        setResponse(stack => {
          return {
            ...stack,
            itemsFull: [...stack.itemsFull, ...results],
            items: isSplice ? [...stack.items] : [...stack.itemsFull, ...results],
            next: res.data.next,
            count: res.data.count,
            onLoadMore: onLoadMore(res.data.next, false),
            loading: false
          }
        })
        if (callback) callback();
      }).catch( e => console.log(`error`, e) );
    }
  }, [state.api, type, onLoadMore]);

  useEffect(() => {
    if (state.api && path) {

      const isCache = false;
      state.api.getFromApiSearch(path, isBaseRootApi, isCache).then( res => { //getFromApi - old
        const results = isBaseRootApi ? ( (res.data[type]) ? res.data[type] : [] ) : res.data.data;
        setResponse({
          id,
          itemsFull: results,
          items: [...results].splice(0, perPage),
          next: res.data.next,
          count: res.data.count,
          loading: false,
          onLoadMore: onLoadMore(res.data.next, false)
        });

      }).catch( e => {
        const sError = JSON.parse(JSON.stringify(e, null, 2));
        if (sError && sError.message && sError.message.includes(`401`)) { // Session Expired
          dispatch(setRequestError(sError));
        }
        setResponse({ id, itemsFull: [], items: [], next: null, loading: false, onLoadMore: null })
      } );

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, path, state.api, perPage, onLoadMore, dispatch]) // warning state.cache

  return [response];
};

export default useGetFromApiSearch;
